import {
  VStack,
  Box,
  Flex,
  Icon,
  Text,
  Grid,
  FormControl,
  FormLabel,
  Input,
  Select,
  Divider,
  Button,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from "@chakra-ui/react";
import {
  FaUser,
  FaEnvelope,
  FaHome,
  FaShareAlt,
  FaTimes,
  FaUniversity,
  FaCalendarAlt,
  FaVenusMars,
  FaBook,
  FaTint,
  FaIdCard,
  FaMale,
  FaFemale,
  FaPhone,
  FaFileAlt,
  FaPlus,
} from "react-icons/fa";

import { useState, useEffect } from "react";
import axios from "axios"; // Import axios for API requests
import { BASE_URL } from "../../../Globalapi/Globalapi";

function AdmissionEnquiryForm() {
  const [classes, setClasses] = useState([]); // State to store fetched classes
  const [genders, setGenders] = useState([]); // State to store fetched genders
  const [bloodGroups, setBloodGroups] = useState([]); // State to store fetched blood groups

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    address: "",
    dob: "", // Changed from date_of_birth to dob for consistency with PHP
    gender_id: "", // Changed to match PHP expected input
    class_id: "", // Changed to match PHP expected input
    blood_group_id: "", // Changed to match PHP expected input
    aadhar_no: "",
    father_name: "",
    mother_name: "",
    father_no: "",
    mother_no: "",
  });

  useEffect(() => {
    // Fetch classes
    axios
      .get(`${BASE_URL}/admin/class/class_master.php`)
      .then((response) => {
        if (response.data.success) {
          setClasses(response.data.data);
        } else {
          console.error("Error fetching class data");
        }
      })
      .catch((error) => {
        console.error("Error fetching class data:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch blood groups and genders
    axios
      .get(`${BASE_URL}/admin/staff/blood_group_master.php`)
      .then((response) => setBloodGroups(response.data.data || []))
      .catch((error) => console.error("Error fetching blood groups:", error));

    axios
      .get(`${BASE_URL}/admin/staff/gender_master.php`)
      .then((response) => setGenders(response.data.data || []))
      .catch((error) => console.error("Error fetching genders:", error));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    // Prepare the data for submission
    const dataToSubmit = {
      name: formData.name,
      email: formData.email,
      address: formData.address,
      dob: formData.dob,
      gender_id: parseInt(formData.gender_id), // Convert to integer as expected by PHP
      class_id: parseInt(formData.class_id), // Convert to integer as expected by PHP
      blood_group_id: parseInt(formData.blood_group_id), // Convert to integer as expected by PHP
      aadhar_no: formData.aadhar_no,
      father_name: formData.father_name,
      mother_name: formData.mother_name,
      father_no: formData.father_no,
      mother_no: formData.mother_no,
    };
    console.log(dataToSubmit);

    // Make the API call to save the admission enquiry
    axios
      .post(`${BASE_URL}/admin/admission/create_admission.php`, dataToSubmit)
      .then((response) => {
        console.log("enquiry sbmission:", response);
        if (response.data.success) {
          // Success message or action
          console.log(
            "Admission enquiry submitted successfully:",
            response.data.message
          );
          // Reset the form after submission
          setFormData({
            name: "",
            email: "",
            address: "",
            dob: "",
            gender_id: "",
            class_id: "",
            blood_group_id: "",
            aadhar_no: "",
            father_name: "",
            mother_name: "",
            father_no: "",
            mother_no: "",
          });
          onClose(); // Close modal after submission
        } else {
          console.error("Submission failed:", response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error submitting enquiry:", error);
      });
  };

  return (
    <>
      <Button colorScheme="teal" onClick={onOpen} leftIcon={<FaPlus />}>
        <Box display={{ base: "none", md: "block" }}>Enquiry</Box>
      </Button>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)" // Light teal gradient
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <IconButton
            aria-label="Close"
            icon={<FaTimes />}
            position="absolute"
            top={3}
            right={3}
            size="lg"
            variant="ghost"
            color="teal.600"
            _hover={{ bg: "teal.100" }}
            onClick={onClose}
          />
          <ModalHeader
            marginTop={0}
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            <Icon as={FaUniversity} boxSize={5} mr={2} />
            Admission Enquiry Form
          </ModalHeader>

          <ModalBody
            overflowY="auto"
            px={4}
            maxH="400px"
            css={{
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            <VStack spacing={4} align="stretch">
              {/* Personal Details */}
              <Grid
                templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
                gap={4}
              >
                <FormControl id="name" isRequired>
                  <FormLabel>
                    <Icon as={FaUser} mr={1} color="teal.500" /> Name
                  </FormLabel>
                  <Input
                    type="text"
                    placeholder="Enter your name"
                    name="name"
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    value={formData.name}
                    onChange={handleChange}
                  />
                </FormControl>

                <FormControl id="email" isRequired>
                  <FormLabel>
                    <Icon as={FaEnvelope} mr={1} color="teal.500" /> Email
                  </FormLabel>
                  <Input
                    type="email"
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    placeholder="Enter your email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </FormControl>

                <FormControl id="address" isRequired>
                  <FormLabel>
                    <Icon as={FaHome} mr={1} color="teal.500" /> Address
                  </FormLabel>
                  <Input
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    type="text"
                    placeholder="Enter your address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </FormControl>

                <FormControl id="dob" isRequired>
                  <FormLabel>
                    <Icon as={FaCalendarAlt} mr={1} color="teal.500" /> Date of
                    Birth
                  </FormLabel>
                  <Input
                    type="date"
                    name="dob"
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    value={formData.dob}
                    onChange={handleChange}
                  />
                </FormControl>
              </Grid>

              <Grid
                templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
                gap={4}
              >
                <FormControl id="hear_about_us" isRequired>
                  <FormLabel>
                    <Icon as={FaShareAlt} mr={1} color="teal.500" /> How did you
                    hear about us?
                  </FormLabel>
                  <Select
                    name="hear_about_us"
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    value={formData.hear_about_us}
                    onChange={handleChange}
                    placeholder="Select an option"
                  >
                    <option value="social_media">Social Media</option>
                    <option value="friends">Friends</option>
                    <option value="website">Website</option>
                    <option value="other">Other</option>
                  </Select>
                </FormControl>
                <FormControl id="gender" isRequired>
                  <FormLabel>
                    <Icon as={FaVenusMars} mr={1} color="teal.500" /> Gender
                  </FormLabel>
                  <Select
                    name="gender_id"
                    value={formData.gender_id}
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    onChange={handleChange}
                    placeholder="Select Gender"
                  >
                    {genders.map((gender) => (
                      <option key={gender.id} value={gender.id}>
                        {gender.gender}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                <FormControl id="class" isRequired>
                  <FormLabel>
                    <Icon as={FaBook} mr={1} color="teal.500" /> Class
                  </FormLabel>
                  <Select
                    name="class_id"
                    value={formData.class_id}
                    onChange={handleChange}
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    placeholder="Select Class"
                  >
                    {classes.map((cls) => (
                      <option key={cls.id} value={cls.id}>
                        {cls.class}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Divider borderColor="gray.300" />

              {/* Additional Information */}
              <Grid
                templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
                gap={4}
              >
                <FormControl id="blood_group" isRequired>
                  <FormLabel>
                    <Icon as={FaTint} mr={1} color="teal.500" /> Blood Group
                  </FormLabel>
                  <Select
                    name="blood_group_id"
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    value={formData.blood_group_id}
                    onChange={handleChange}
                    placeholder="Select Blood Group"
                  >
                    {bloodGroups.map((group) => (
                      <option key={group.id} value={group.id}>
                        {group.group}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                <FormControl id="aadhar_no" isRequired>
                  <FormLabel>
                    <Icon as={FaIdCard} mr={1} color="teal.500" /> Aadhar Number
                  </FormLabel>
                  <Input
                    type="text"
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    placeholder="Enter Aadhar Number"
                    name="aadhar_no"
                    value={formData.aadhar_no}
                    onChange={handleChange}
                  />
                </FormControl>

                <FormControl id="father_name" isRequired>
                  <FormLabel>
                    <Icon as={FaMale} mr={1} color="teal.500" /> Father Name
                  </FormLabel>
                  <Input
                    placeholder="Enter Father's Name"
                    name="father_name"
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    value={formData.father_name}
                    onChange={handleChange}
                  />
                </FormControl>

                <FormControl id="mother_name" isRequired>
                  <FormLabel>
                    <Icon as={FaFemale} mr={1} color="teal.500" /> Mother Name
                  </FormLabel>
                  <Input
                    placeholder="Enter Mother's Name"
                    name="mother_name"
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    value={formData.mother_name}
                    onChange={handleChange}
                  />
                </FormControl>
                <FormControl id="father_no">
                  <FormLabel>
                    <Icon as={FaPhone} mr={1} color="teal.500" /> Father Contact
                    No
                  </FormLabel>
                  <Input
                    placeholder="Enter Father's Contact No"
                    name="father_no"
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    value={formData.father_no}
                    onChange={handleChange}
                  />
                </FormControl>

                <FormControl id="mother_no">
                  <FormLabel>
                    <Icon as={FaPhone} mr={1} color="teal.500" /> Mother Contact
                    No
                  </FormLabel>
                  <Input
                    placeholder="Enter Mother's Contact No"
                    name="mother_no"
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    value={formData.mother_no}
                    onChange={handleChange}
                  />
                </FormControl>
              </Grid>
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default AdmissionEnquiryForm;
